import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { CommentItem } from 'components';
import './styles.css';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/actions/commentActions';
import MiniLoader from 'components/MiniLoader';
import { Translate, I18n } from 'react-redux-i18n';
import { Camera, Cancel, Send } from 'theme/icon';

const Comments = (props) => {
    const location = useLocation();
    const { item, user_id, token } = props;

    const [values, setValues] = useState({
        comment: '',
        image: '',
        file: '',
        hasFile: false,
        comment_id: '',
    });

    useEffect(() => {
        const commentId = new URLSearchParams(location.search).get('id');
        if (!commentId || !user_id) {
            return;
        }
        props.loadItem({ comment_id: commentId, id: user_id }, token);
    }, [location.search, user_id, token]);

    useEffect(() => {
        if (!user_id || !item?.id) {
            return;
        }
        props.loadList({ id: user_id, comment_id: item.id }, token);
        setValues((prev) => ({
            ...prev,
            comment_id: item.id,
        }));
    }, [user_id, item?.id, token]);

    const onClickSend = () => {
        if (!user_id || !item?.id) {
            return;
        }

        const text = values.comment.trim();
        if (!text && !values.file) {
            return;
        }

        if (values.file) {
            const params = new FormData();
            params.append('comment', text || ' ');
            params.append('id', user_id);
            params.append('comment_id', item.id);
            params.append('file', values.file);
            props.newItem(params, token, values.image);
        } else {
            props.newItem({
                comment: text,
                id: user_id,
                comment_id: item.id,
            }, token);
        }
        setValues({
            comment: '',
            image: '',
            file: '',
            hasFile: false,
            comment_id: item.id,
        });
    };

    const onClickCloseImg = () => {
        setValues((prev) => ({
            ...prev,
            file: '',
            image: '',
            hasFile: false,
        }));
    };

    const onChange = (event) => {
        const { name, value } = event.target;
        setValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onClickUp = (commentItem) => {
        props.updateLike({
            comment_id: commentItem.id,
            id: user_id,
            reaction: '1',
        }, token);
    };

    const onClickDown = (commentItem) => {
        props.updateLike({
            comment_id: commentItem.id,
            id: user_id,
            reaction: '2',
        }, token);
    };

    const onClickComment = (commentItem) => {
        props.setItem({ item: commentItem });
    };

    const onChangeImage = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setValues((prev) => ({
                ...prev,
                file,
                image: reader.result,
                hasFile: true,
            }));
        };
        reader.readAsDataURL(file);
    };

    const onClickLoadMore = () => {
        if (!user_id || !item?.id) {
            return;
        }
        props.loadMore({
            id: user_id,
            comment_id: item.id,
            index: props.pageCount,
        }, token);
    };

    if (!item?.id) {
        return (
            <div className="wall-container comment-thread-empty">
                <p>Abre un hilo desde el muro o desde una notificación para ver la conversación.</p>
                <RouterLink to="/wall" className="btn btn-primary">
                    Ir al muro
                </RouterLink>
            </div>
        );
    }

    return (
        <div className="wall-container comment-thread">
            <div className="comment-thread-scroll">
                <div className="comment-thread-parent">
                    <CommentItem
                        item={item}
                        onClickUp={() => onClickUp(item)}
                        onClickDown={() => onClickDown(item)}
                        onClickComment={() => onClickComment(item)}
                    />
                </div>

                <h3 className="comment-replies-title">
                    Respuestas {props.list.length > 0 ? `(${props.list.length})` : ''}
                </h3>

                {props.loading && props.list.length === 0 && (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                        <MiniLoader />
                    </div>
                )}

                {props.list.map((reply) => (
                    <CommentItem
                        key={reply.id}
                        item={reply}
                        onClickUp={() => onClickUp(reply)}
                        onClickDown={() => onClickDown(reply)}
                        onClickComment={() => onClickComment(reply)}
                    />
                ))}

                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                    {props.pageSize === 25 && (
                        props.loadingMore ? (
                            <MiniLoader />
                        ) : (
                            <button className="btn btn-primary" type="button" onClick={onClickLoadMore}>
                                <Translate value="load_more" />
                            </button>
                        )
                    )}
                </div>
            </div>

            <div className="card wall-compose comment-compose">
                {values.hasFile && (
                    <div className="comment-compose-preview">
                        <div className="comment-compose-preview-header">
                            <span className="icon-button" aria-label="Remove image" onClick={onClickCloseImg}>
                                <Cancel />
                            </span>
                        </div>
                        <img src={values.image} alt="Preview" className="img-responsive" />
                    </div>
                )}

                <span aria-label="upload picture">
                    <input
                        hidden
                        accept="image/*"
                        type="file"
                        id="comment_reply_img"
                        name="open_img"
                        onChange={onChangeImage}
                    />
                    <label htmlFor="comment_reply_img" className="icon-button" style={{ cursor: 'pointer' }}>
                        <Camera />
                    </label>
                </span>

                <div style={{ width: '100%' }}>
                    <textarea
                        className="text_comment"
                        rows={2}
                        placeholder={I18n.t('what_you_mind')}
                        name="comment"
                        onChange={onChange}
                        value={values.comment}
                    />
                </div>

                <span className="icon-button" aria-label="Send reply" onClick={onClickSend}>
                    <Send />
                </span>
            </div>
        </div>
    );
};

Comments.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.comment.list,
        error: reducer.comment.error,
        loading: reducer.comment.loading,
        item: reducer.comment.item,
        pageCount: reducer.comment.page_count,
        pageSize: reducer.comment.page_size,
        loadingMore: reducer.comment.loadingMore,
    };
}

const mapDispatchToProps = (dispatch) => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    newItem: (params, token, previewMedia) =>
        dispatch(actions.newItem({ params, token, previewMedia })),
    updateLike: (params, token) =>
        dispatch(actions.updateLike({ params, token })),
    setItem: (data) =>
        dispatch(actions.setItem(data)),
    loadMore: (params, token) =>
        dispatch(actions.loadListScroll({ params, token })),
    loadItem: (params, token) =>
        dispatch(actions.loadItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
